import { memo, type ReactNode } from 'react';
import { Handle, Position, type Node, type NodeProps } from '@xyflow/react';

export type TurboNodeData = {
    label: ReactNode;
    icon?: ReactNode;
    handlePositions?: {
        target?: Position | { angle: number };
        source?: Position | { angle: number };
    };
};

const calculateHandlePosition = (angle: number) => {
    if (angle >= 45 && angle < 135) return Position.Top;
    if (angle >= 135 && angle < 225) return Position.Right;
    if (angle >= 225 && angle < 315) return Position.Bottom;
    return Position.Left;
};

export default memo(({ data, isConnectable }: NodeProps<Node<TurboNodeData>>) => {
    const targetPosition = data.handlePositions?.target;
    const sourcePosition = data.handlePositions?.source;

    return (
        <>
            <Handle
                type="target"
                position={
                    typeof targetPosition === 'object' && 'angle' in targetPosition
                        ? calculateHandlePosition(targetPosition.angle)
                        : targetPosition || Position.Left
                }
                isConnectable={isConnectable}
                className="turbo-node-handle"
            />

            <div className="wrapper gradient">
                <div className="inner">
                    <div className="turbo-node">
                        {data.icon}
                        <div className="turbo-node-content">{data.label}</div>
                    </div>
                </div>
            </div>

            <Handle
                type="source"
                position={
                    typeof sourcePosition === 'object' && 'angle' in sourcePosition
                        ? calculateHandlePosition(sourcePosition.angle)
                        : sourcePosition || Position.Right
                }
                isConnectable={isConnectable}
                className="turbo-node-handle"
            />
        </>
    );
});
